<div class="endorsement-box">
  <div class="endorse-action-row">
    <button
      class="close-button secondary_materials_button "
      disableRipple="true"
      type="button"
      mat-stroked-button
      [disabled]="!canStartCostCorrection"
      [attr.title]="student?.hasPendingCostCorrection
        ? 'A cost correction is already in progress for this student.'
        : null"
      (click)="onCostCorrection()">
      Cost Correction
    </button>
    <button
      class="close-button secondary_materials_button "
      disableRipple="true"
      type="button"
      mat-stroked-button
      (click)="onWithdrawal()">
      Withdrawal / Transfer
    </button>
  </div>
</div>
